export default (selectedLanguage) =>
  new Promise((resolve, reject) => {
    window.axios
      .delete(`${process.env.VUE_APP_API_ADMIN_LOCATION}homefeed/section/trash?language=${selectedLanguage}`)
      .then(() => resolve())
      .catch((error) => {
        reject(error);
      });
  });
